import React, { ChangeEvent, FC } from 'react'
import { DayOfWeekCheckbox } from 'components/Form'
import { FlexColumn, FlexRow } from 'components/Flex'
import { Spacer } from 'components/Utility'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { StockUnionType } from 'types/stock'

type Props = {
  daysOfWeek: DayOfWeekType[]
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  index?: number
  selectDaysOfWeek?: (dayOfWeek: DayOfWeekType) => void
  selectableDaysOfWeek?: DayOfWeekType[]
  type?: StockUnionType
  wrap: boolean
}

const DaysOfWeekPicker: FC<Props> = (props) => {
  const {
    daysOfWeek,
    onChange,
    selectDaysOfWeek,
    selectableDaysOfWeek = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun', 'hol'],
    index,
    type,
    wrap,
  } = props

  const weekdays: DayOfWeekType[] = ['mon', 'tue', 'wed', 'thu', 'fri']
  const weekend: DayOfWeekType[] = ['sat', 'sun', 'hol']

  return (
    <FlexColumn alignItems={'center'}>
      {wrap ? (
        <>
          <FlexRow justifyContent={'center'}>
            {weekdays.map((dayOfWeek) => (
              <React.Fragment key={`${type}-${index}-${dayOfWeek}`}>
                <DayOfWeekCheckbox
                  disabled={!selectableDaysOfWeek.includes(dayOfWeek)}
                  id={
                    typeof index !== 'undefined'
                      ? typeof type !== 'undefined'
                        ? `${type}-${index}-${dayOfWeek}`
                        : `${index}-${dayOfWeek}`
                      : dayOfWeek
                  }
                  isChecked={daysOfWeek.includes(dayOfWeek)}
                  onChange={onChange}
                  selectDaysOfWeek={selectDaysOfWeek}
                  value={dayOfWeek}
                />
                {dayOfWeek !== 'fri' && <Spacer size={8} />}
              </React.Fragment>
            ))}
          </FlexRow>
          <Spacer size={8} />
          <FlexRow justifyContent={'center'}>
            {weekend.map((dayOfWeek) => (
              <React.Fragment key={`${type}-${index}-${dayOfWeek}`}>
                <DayOfWeekCheckbox
                  disabled={!selectableDaysOfWeek.includes(dayOfWeek)}
                  id={
                    typeof index !== 'undefined'
                      ? typeof type !== 'undefined'
                        ? `${type}-${index}-${dayOfWeek}`
                        : `${index}-${dayOfWeek}`
                      : dayOfWeek
                  }
                  isChecked={daysOfWeek.includes(dayOfWeek)}
                  onChange={onChange}
                  selectDaysOfWeek={selectDaysOfWeek}
                  value={dayOfWeek}
                />
                {dayOfWeek !== 'hol' && <Spacer size={8} />}
              </React.Fragment>
            ))}
          </FlexRow>
        </>
      ) : (
        <FlexRow justifyContent={'center'}>
          {[...weekdays, ...weekend].map((dayOfWeek) => {
            return (
              <React.Fragment key={`${type}-${index}-${dayOfWeek}`}>
                <DayOfWeekCheckbox
                  disabled={!selectableDaysOfWeek.includes(dayOfWeek)}
                  id={
                    typeof index !== 'undefined'
                      ? typeof type !== 'undefined'
                        ? `${type}-${index}-${dayOfWeek}`
                        : `${index}-${dayOfWeek}`
                      : dayOfWeek
                  }
                  isChecked={daysOfWeek.includes(dayOfWeek)}
                  onChange={onChange}
                  selectDaysOfWeek={selectDaysOfWeek}
                  value={dayOfWeek}
                />
                {dayOfWeek !== 'hol' && <Spacer size={8} />}
              </React.Fragment>
            )
          })}
        </FlexRow>
      )}
    </FlexColumn>
  )
}
export default DaysOfWeekPicker
